<template>
  <div class="notify-wrapper" v-if="info && info.id">
    <div class="notify-pdp-image">
      <ImgHoverZoom :img-def="selectedColor.cover" :img-zoom="selectedColor.cover" />
    </div>
    <div class="notify-pdp-info">
      <h1 class="pdp-item-name">{{ info.name }}</h1>
      <div class="pdp-item-skus">
        <ul class="pdp-item-sku-options">
          <!-- 颜色 -->
          <li class="pdp-item-sku-option" v-if="info.colors && info.colors.length">
            <h2 class="pdp-item-sku-header">
              颜色:
              <span class="pdp-item-sku-colors" v-if="selectedColor">{{ selectedColor.name }}</span>
            </h2>
            <ul class="pdp-item-sku-color-list">
              <li :class="['pdp-item-sku-color-item', selectedColor.id == color.id ? 'active' : '']"
                v-for="(color, i) in info.colors" :key="i" @click="setColor(color)">
                <img :src="color.cover" />
              </li>
            </ul>
          </li>
          <!-- 尺寸 -->
          <li class="pdp-item-sku-option" v-if="info.sizes && info.sizes.length">
            <h2 class="pdp-item-sku-header">
              尺寸:
              <span class="pdp-item-sku-colors" v-if="selectedSize">{{ selectedSize.name }}</span>
              <router-link to="/size-guide" target="_blank" class="pdp-size-guide">尺码表</router-link>
            </h2>
            <ul class="pdp-item-sku-size-list">
              <li class="pdp-item-sku-size-item" v-for="(size, i) in info.sizes" @click="setSize(size)" :key="i">
                <a :class="[selectedSize.id == size.id ? 'active' : '']">{{ size.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="pdp-item-notification">
        <div class="notify-target">
          <label class="notify-label">手机号码*</label>
          <input class="notify-input" type="text" required v-model.trim="mobile" placeholder="请输入手机号码"
            @blur="toCheck" />
          <span v-if="mobileMsg" class="notify-hits">{{ mobileMsg }}</span>
        </div>
        <div class="notify-privacy-policy">
          <span @click="togglePrivacy">
            <i class="iconfont">{{ agreePrivacy ? '&#xedaf;' : '&#xec58;' }}</i>
            <label>我愿意接收来自鬼塚虎的通知。</label>
          </span>
        </div>
        <p class="notify-agree">
          我已仔细阅读并同意鬼塚虎
          <router-link title="Privacy Policy" target="_blank" to="/privacy-policy?active=0">隐私政策</router-link>
        </p>
        <button type="button" class="notify-btn" :disabled="notifyStatus" @click="sendNotify">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgHoverZoom from '@/components/ImgHoverZoom.vue';
import types from "@/store/types";
import api from "@/utils/api";

export default {
  name: 'ItemNotify',
  components: { ImgHoverZoom },
  props: {
    id: {
      type: [Number, String],
      validator(value) {
        if (value && isNaN(value)) return false;
        return true;
      }
    },
    color: {
      type: [Number, String],
      validator(value) {
        if (value && isNaN(value)) return false;
        return true;
      }
    },
    source: Object,
    confirmText: {
      type: String,
      default: "到货通知"
    }
  },
  data() {
    return {
      info: null,
      selectedColor: null,
      selectedSize: null,
      mobile: "",
      mobileMsg: '',
      agreePrivacy: true
    }
  },
  created() {
    if (this.id && this.color) {
      this.loadItemSource(this.id, this.color);
    } else if (this.source) {
      this.setValue(this.source);
    } else {
      console.log('缺少参数');
    }
  },
  methods: {
    // 数据加载
    loadItemSource(id, color) {
      api[types.GET_DETAIL](id, color)
        .then(res => {
          if (res?.code == 1) {
            this.setValue(res.data);
          } else {
            console.warn(res);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    // 数据处理
    setValue(data) {
      let info = JSON.parse(JSON.stringify(data));
      // 过滤出没有库存的颜色
      // info.colors = info.colors.filter(colorItem => colorItem.stock <= 0);
      // 设置默认选中的颜色
      if (info.colors.length) {
        if (!this.selectedColor) {
          this.selectedColor = info.colors[0];
        }
      }
      // // 过滤出没有库存的尺寸
      info.sizes = info.sizes.filter(sizeItem => sizeItem.stock < 1);
      // 设置默认选中的尺寸
      if (info.sizes) {
        this.selectedSize = info.sizes[0];
      } else {
        this.selectedSize = null;
      }
      // 
      this.info = info;
    },
    // 选择颜色
    setColor(color) {
      this.selectedColor = color;
      this.loadItemSource(this.info.id, this.selectedColor.id);
    },
    // 选择尺寸
    setSize(size) {
      this.selectedSize = size;
    },
    // 手机号校验
    toCheck(evt) {
      let dom = evt.target || evt.srcElement;
      if (!dom.value) {
        this.mobileMsg = "该项为必填项.";
      } else if (!/^1[3456789]\d{9}$/.test(dom.value)) {
        this.mobileMsg = "请输入正确的手机号";
      } else {
        this.mobileMsg = '';
      }
    },
    togglePrivacy() {
      this.agreePrivacy = !this.agreePrivacy;
    },
    // 发送通知
    sendNotify() {
      let { info, selectedColor: color, selectedSize: size, mobile } = this;
      let newArgs = {
        id: info.id,
        color: color.id,
        sku: size.id,
        mobile: mobile
      };
      api[types.NOTIFY](newArgs).then(res => {
        if (res?.code == 1) {
          this.$message({ type: "success", message: res.message || "操作成功" });
          this.$emit("comfirm");
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  },
  computed: {
    // 发送到货通知按钮的状态控制
    notifyStatus() {
      let { selectedColor: color, selectedSize: size, mobile, agreePrivacy } = this;
      if (color?.id && size?.id && /^1[3456789]\d{9}$/.test(mobile) && agreePrivacy) {
        return false;
      }
      return true;
    }
  },
  watch: {
    'source'() {
      this.setValue(this.source);
    }
  }
};
</script>

<style lang="scss" scoped>
.notify-wrapper {
  display: flex;
  width: 100%;

  .notify-pdp-image {
    border: 1px solid #b4b5b4;
    width: 36.81%;
    box-sizing: border-box;
    padding: 20px 45px 36px;
    background: #fff;

    overflow-y: auto;
    max-height: 80vh;
  }

  .notify-pdp-info {
    border: 1px solid #b4b5b4;
    margin-left: 2%;
    width: 63.18%;
    padding: 15px 20px;
    box-sizing: border-box;
    background: #fff;

    overflow-y: auto;
    max-height: 80vh;

    .pdp-item-name {
      font-size: 20px;
      // font-size: calc(1.625rem * 1.6);
      font-weight: 400;
      line-height: calc(1.625rem * 1.6);
      letter-spacing: 0.05em;
      text-align: left;
    }

    .pdp-item-skus {
      margin-top: 10px;

      .pdp-item-sku-options {
        margin-top: 8px;

        .pdp-item-sku-option {
          box-sizing: border-box;
          margin: 0 0 20px;
          padding: 0;
          border: 0;
          width: 100%;
          float: none;
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          line-height: calc(1.5rem * 1.6);

          .pdp-item-sku-header {
            font-size: calc(0.875rem * 1.6);
            font-weight: 700;
            line-height: calc(1rem * 1.6);
            margin: 0 0 5px;
            color: #000;
            text-align: left;

            .pdp-item-sku-colors {
              margin-left: 5px;
              font-weight: 400;
              text-transform: none;
              font-size: calc(0.875rem * 1.6);
            }

            .pdp-size-guide {
              line-height: 1.5rem;
              float: right;
              font-weight: 400;
              font-size: 0.75rem;
              margin-bottom: 10px;
              color: #000;
              text-transform: capitalize;
              text-decoration: underline;
            }
          }

          .pdp-item-sku-color-list {
            clear: both;
            overflow: auto;
            padding: 0;
            list-style: none;
            margin-top: 8px;

            // &::after { clear: both; content: ''; }
            .pdp-item-sku-color-item {
              width: 20%;
              max-width: 60px;
              line-height: 0;
              font-weight: 400;
              font-size: 0.875rem;
              float: left;
              box-sizing: border-box;
              margin: 0;
              font-weight: 700;
              padding: 10px;
              cursor: pointer;
              position: relative;

              img {
                width: 100%;
                height: auto;
              }

              &.active {
                box-shadow: inset 0 0 0 2px #000;
              }
            }
          }

          .pdp-item-sku-size-list {
            clear: both;
            overflow: auto;
            padding: 0;
            list-style: none;
            border-left: 1px solid #4d4d4c;

            .pdp-item-sku-size-item {
              font-weight: 400;
              font-size: calc(0.875rem * 1.6);
              float: left;
              box-sizing: border-box;
              margin: 0;
              border-bottom: 1px solid #4d4d4c;
              border-right: 1px solid #4d4d4c;
              width: 14.28%;
              line-height: calc(1.5rem * 1.6);

              &:nth-child(-n + 7) {
                border-top: 1px solid #4d4d4c;
              }

              a {
                position: relative;
                display: block;
                padding: 10px;
                color: #000;
                text-decoration: none;
                text-align: center;
                text-transform: uppercase;
                cursor: pointer;
                font-size: 0.75rem;
                letter-spacing: 0.025em;
                overflow: hidden;
                font-weight: 400;

                &:hover {
                  color: #000;
                  text-decoration: none;
                  font-weight: 700;
                }

                &.active {
                  font-weight: 700;
                  box-shadow: inset 0 0 0 2px #000;
                }
              }
            }
          }
        }
      }
    }

    .pdp-item-notification {
      text-align: left;

      .notify-target {
        padding-bottom: 15px;

        .notify-label {
          font-size: calc(.875rem * 1.6);
          letter-spacing: .025em;
          display: block;
          margin-bottom: 5px;
          color: #000;
          box-sizing: border-box;
          text-align: left;
          white-space: normal;
          clear: both;
          text-transform: uppercase;
        }

        .notify-input {
          width: 100%;
          height: 40px;
          font-weight: 400;
          font-size: calc(.875rem * 1.6);
          box-sizing: border-box;
          padding: 0 10px;
          text-indent: 0;
          margin-bottom: 5px;
          border: 1px solid #b4b5b4;
          border-radius: 2px;
          background-color: #fff;

          &:focus {
            border: 1px solid #000;
          }

          &:invalid {
            border: 1px solid #bd0025;
            // &+.notify-hits { display: block; }
          }
        }

        .notify-hits {
          // display: none;
          position: relative;
          left: 0;
          bottom: 0;
          font-size: calc(.6875rem * 1.6);
          color: #bd0025;
          margin-top: 4px;
        }
      }

      .notify-privacy-policy {
        padding-bottom: 20px;

        span {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          label {
            margin-left: 5px;
            font-weight: 400;
            cursor: pointer;
          }
        }
      }

      .notify-agree {
        font-weight: 400;
        font-size: calc(.75rem * 1.6);

        a {
          font-weight: 400;
          font-size: calc(.75rem * 1.6);
          text-decoration: underline;
          color: #333;
        }
      }

      .notify-btn {
        box-sizing: border-box;
        display: block;
        margin: 20px auto 0;
        padding: 0 30px;
        width: 65%;
        color: #fff;
        font-size: calc(1rem * 1.6);
        font-weight: 400;
        line-height: 38px;
        text-align: center;
        letter-spacing: normal;
        text-decoration: none;
        text-transform: uppercase;
        border: 1px solid #7f0019;
        border-color: #7f0019;
        border-radius: 2px;
        background-color: #7f0019;
        transition: all .3s ease;
        cursor: pointer;

        &[disabled] {
          opacity: .5;
        }
      }
    }
  }
}

@media only screen and (min-width: 769px) {
  .notify-wrapper {
    .notify-pdp-image {
      overflow-y: auto;
      max-height: 80vh;
    }

    .notify-pdp-info {
      overflow-y: auto;
      max-height: 80vh;
    }
  }
}

@media only screen and (max-width: 768px) {
  .notify-wrapper {
    flex-direction: column;

    .notify-pdp-image {
      width: 100%;
      padding: 0;
      border: 0;
    }

    .notify-pdp-info {
      width: 100%;
      margin-left: 0;
      border: 0;

      .pdp-item-name {
        display: none;
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .notify-wrapper {
    .notify-pdp-info {
      .pdp-item-skus {
        .pdp-item-sku-options {
          .pdp-item-sku-option {
            .pdp-item-sku-size-list {
              .pdp-item-sku-size-item {
                a {
                  padding: 5px;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>